import PlaceTargetList from "./PlaceTargetList";
import PlaceTargetCreate from "./PlaceTargetCreate";
import PlaceTargetEdit from "./PlaceTargetEdit";
import PlaceTargetShow from "./PlaceTargetShow";
import PlaceTargetIcon from "@mui/icons-material/GpsFixed";

const PlaceTargets = {
  list: PlaceTargetList,
  create: PlaceTargetCreate,
  edit: PlaceTargetEdit,
  show: PlaceTargetShow,
  icon: PlaceTargetIcon,
};

export default PlaceTargets;
